import ChoiceListSection from './ChoiceListSection.jsx';

const DatePresetsSection = ({ section }) => (
  <ChoiceListSection section={section} control="radio" multiple={false} maxVisible={8} />
);

export default DatePresetsSection;
